import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import momentZone from 'moment-timezone';

@Component({
  selector: 'app-timezone-picker',
  templateUrl: './custom-timezone-picker.component.html',
  styleUrls: ['./custom-timezone-picker.component.css']
})

export class CustomTimezonePickerComponent implements OnInit {

  @Input() customPlaceholderText: string = 'Time Zone';
  @Input() group: string = 'group';
  @Input() isDisabled: boolean = false;
  @Input() isClearable: boolean = true;
  @Input() setDefaultValue: string = 'Asia/Kolkata (+05:30)';
  @Output() formControlValue: EventEmitter<string> = new EventEmitter();

  public timezones = [];

  constructor() {}

  formatZone = (zone: string): any => {
    const foundZone = momentZone.tz(zone);
    const utc: string = foundZone.format('Z');
    const abbr: string = foundZone.zoneAbbr();
    return {
      name: `${zone} (${utc})`,
      nameValue: zone,
      timeValue: utc,
      group: zone.split('/', 1)[0],
      abbr: abbr
    };
  };

  ngOnInit() {
    this.timezones = momentZone.tz.names().map((zone: string) => this.formatZone(zone));
    setTimeout(() => {
      if(!!this.setDefaultValue) {
        this.setDefaultValue = this.timezones.find(t => t.nameValue === this.setDefaultValue).name;
      }
    }, 200)
  }

  onSelected (event) {
    this.formControlValue.emit(event)
  }
}
